import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import Dashboard from "./components/Dashboard/Dashboard";
import Dashboard2 from "./components/Dashboard/Dashboard2";
import CreateTemplate from "./components/Whatsapp/Create_Template";
import Chats from "./components/Whatsapp/Chats";
import CreateCampaign from "./components/Whatsapp/Create Campaign";
import UserManagement from "./components/Profile/UserManagement";
import SupportCenter from "./components/Profile/SupportCenter";
import DLTTamplate from "./components/Whatsapp/TemplateStatus";
import ProfileSetting from "./components/Profile/ProfileSetting";
import Campaign from "./components/Whatsapp/Campaign";
import IdentityPage from "./components/IdentityPage";
import NavigationBar from "./components/DesktopNav";
import Privacy from "./components/Landing_Page/Landing_Privacy";
import TAndC from "./components/Landing_Page/Landing_T&C";
import CampaignDetails from "./components/Whatsapp/campaign_details";
import CampaignView from "./components/Whatsapp/campaign_view";
import TemplateView from "./components/Whatsapp/template_view";
import TemplateEdit from "./components/Whatsapp/Template_Edit";
import ChatBot from "./components/Whatsapp/Chat_Bot";
import Logs from "./components/Whatsapp/Logs";

import Home from "./components/Landing_Page/Home_Page/Home_Page";
import ContactBook from "./components/Whatsapp/Contact_Book";
import WelcomePage from "./components/Profile/WelcomePage";
import TemplateLibrary from "./components/Whatsapp/TemplateLibrary";
import ExpiredPlan from "./components/ExpiredPlan";
import MyLanding from "./components/Main_Landing_Page/Main_Landing_Page";
import Setup from "./components/Profile/Setup";
import "./App.css";
// Admin imports here
import StatisticsDashboard from "./components/Admin/AdminStatic";
import Login from "./components/Admin/AdminLogin";
import { initGA, logPageView } from "./analytics";
import ChatComponent from "./components/Admin/AdminWhitelist";
import ClientCreationPage from "./components/Admin/Clients/CreateClient";
import AdminSideNav from "./components/Admin/AdminSideNav";
import OrderSettings from "./components/Profile/OrderSettings";
import FacebookOnBoarding from "./components/OnBoarding/FacebookOnBoarding";
import EditLibrary from "./components/Whatsapp/LibraryEdit";
import LoginPage from "./components/Admin/WoSenderAdmin";
import AdminDashboard from "./components/Admin/AdminDashboard";
import ClientAccordionTable from "./components/Admin/Clients/AdminClients";
import AdminCampaigns from "./components/Admin/Clients/AdminCampaigns";
// Billing Section
import Billing from "./components/Billing/Billing";

// sign up Import
import Signup from "./components/Signup/Signup";
import Aboutpage from "./components/Landing_Page/Home Section/figma/Aboutpage";
import WhatsappCampaign from "./components/Landing_Page/Home Section/figma/WhatsappCampaign";
import AudienceTargating from "./components/Landing_Page/Home Section/figma/AudienceTargating";
import PersonalisedMessage from "./components/Landing_Page/Home Section/figma/PersonalisedMessage";
import AutomatedReply from "./components/Landing_Page/Home Section/figma/AutomatedReply";
import Pricing from "./components/Landing_Page/Home Section/figma/Pricing";
import Pricingpage from "./components/Landing_Page/Home Section/figma/Pricingpage";
import ScrollToTop from "./components/Landing_Page/Home Section/figma/ScrollToTop";
import { ToastContainer, toast } from "react-toastify";
import { useContext } from "react";
import MyContext from "./MyContext";
import ChatBotHome from "./components/Landing_Page/Home_Page/ChatBotHome";
import ExternalChatBot from "./components/Landing_Page/ChatBotWidget";

const TrackPageView = () => {
  const location = useLocation();
  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);
  return null;
};
// let beepSound = new Audio(beepSoundmp3);
// beepSound.loop = true;
// beepSound.load();
const App = () => {
  const { baseUrl } = useContext(MyContext);
  const [user, setUser] = useState(false);
  const [power, setPower] = useState("");
  const [profiles, setProfiles] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userID, setUserID] = useState("");
  const [DeveloperID, setDeveloperID] = useState("");
  const [keyId, setkeyId] = useState("");
  const [NameAdmin, setNameAdmin] = useState();
  const [AdminRole, setAdminRole] = useState();
  const handleAdminLogout = () => {
    setIsAdmin(false);
    sessionStorage.removeItem("AdminUser");
    window.location.href = "https://www.WoSender.com/";
  };
  const [Admin, setAdmin] = useState();
  useEffect(() => {
    const checkAdminUser = () => {
      const storedUser = sessionStorage.getItem("AdminUser");
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser); // Parse the JSON string

        setIsAdmin(true);
        setAdmin(parsedUser);
        setAdminRole(parsedUser.userType);
        setNameAdmin(parsedUser.adname);
      } else {
        setIsAdmin(false);
      }
    };

    checkAdminUser();
    window.addEventListener("storage", checkAdminUser);
    return () => {
      window.removeEventListener("storage", checkAdminUser);
    };
  }, []);

  const handleLogout = () => {
    setUser(false);
    sessionStorage.removeItem("user");
    window.location.href = "https://www.WoSender.com/";
  };

  const sendNewUserEmail = async (user) => {
    // let displayName = "User";

    // if (user.clientName && user.clientName.trim()) {
    //   displayName = user.clientName;
    // } else if (user.firstName) {
    //   displayName = `${user.firstName} ${user.lastName || ""}`.trim();
    // } else if (user.name) {
    //   displayName = user.name;
    // } else if (user.username && user.username.includes("@")) {
    //   displayName = user.username.split("@")[0];
    // }

    const emailToSend = user.email || user.clientNumber || user.username;

    const payload = {
      to: [emailToSend],
      keyid: "7a57255fbb9021f1ac3a52010aa0680h",
      keySecret:
        "1edf18a65735bc6560d62d12ea82b9d28b342157a345654eb5ed8eab2addc890",
      triggerId: "TR-ce6a7222e2e211f0ac3a42010aa0000f",
      variables: {
        user_name: user.username,
        login_link: "https://dhroom.com/",
      },
    };

    try {
      await fetch("https://api.shubhpaisa.com/api/ShubhPaisa/SendEmail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
    } catch (err) {
      console.error("EMAIL API ERROR:", err);
    }
  };

  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      setUser(true);
      const parsedUser = JSON.parse(storedUser);
      setUserID(parsedUser.userid);
      setDeveloperID(parsedUser.devloperId);
      setkeyId(parsedUser.keyId);
      setProfiles(parsedUser);
    } else {
      // login();
      <Home onLoginClick={login} country={country} />;
    }
  }, []);

  useEffect(() => {
    if (!profiles) return;

    const alreadySent = sessionStorage.getItem("welcomeEmailSent");

    if (profiles.userType === "new_user" && !alreadySent) {
      sendNewUserEmail(profiles);

      sessionStorage.setItem("welcomeEmailSent", "true");
    }
  }, [profiles]);

  const login = () => {
    if (process.env.NODE_ENV == "development") {
      window.location.href = `${window.location.origin}/login`;
    } else {
      window.location.href = "https://www.WoSender.com/login";
    }
  };

  const signUp = () => {
    if (process.env.NODE_ENV == "development") {
      window.location.href = `${window.location.origin}/signup`;
    } else {
      window.location.href = "https://www.WoSender.com/signup";
    }
  };

  useEffect(() => {
    const storedPower = sessionStorage.getItem("power");
    if (storedPower) {
      setPower(storedPower);
    }
  }, []);

  // Initialize Google Analytics
  useEffect(() => {
    initGA();
  }, []);

  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://www.anlook.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Identity",
        item: "https://www.anlook.com/identity",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Blogs",
        item: "https://www.anlook.com/blogs",
      },
      {
        "@type": "ListItem",
        position: 4,
        name: "Post",
        item: "https://www.anlook.com/post",
      },
      {
        "@type": "ListItem",
        position: 5,
        name: "Pricing",
        item: "https://www.anlook.com/pricing",
      },
      {
        "@type": "ListItem",
        position: 6,
        name: "Contact",
        item: "https://www.anlook.com/contact",
      },
      {
        "@type": "ListItem",
        position: 7,
        name: "Privacy",
        item: "https://www.anlook.com/PrivacyPolicy",
      },
      {
        "@type": "ListItem",
        position: 8,
        name: "Terms & Conditions",
        item: "https://www.anlook.com/terms-and-conditions",
      },
      {
        "@type": "ListItem",
        position: 9,
        name: "Cancellation",
        item: "https://www.anlook.com/cancellation",
      },
      {
        "@type": "ListItem",
        position: 10,
        name: "About Us",
        item: "https://www.anlook.com/about-us",
      },
    ],
  };

  const [country, setCountry] = useState("");

  useEffect(() => {
    const storedCountry = sessionStorage.getItem("userCountry");
    if (!storedCountry) {
      // If no country in session storage, fetch location from API
      const fetchLocation = async () => {
        try {
          const response = await axios.get(
            `https://api.ipgeolocation.io/ipgeo?apiKey=1e4cf2d0a0ee4ebe92e18c3e52000ebf`,
          );
          const userCountry = response.data.country_code2;
          setCountry(userCountry);
          sessionStorage.setItem("userCountry", userCountry);
        } catch (error) {
          console.error("Error fetching geolocation data:", error);
          setCountry("Other");
        }
      };
      fetchLocation();
    } else {
      // If country is stored in session storage, use it
      setCountry(storedCountry);
    }
  }, []);

  // Function to handle manual country change from dropdown
  const handleCountryChange = (selectedCountry) => {
    setCountry(selectedCountry);
    sessionStorage.setItem("userCountry", selectedCountry);
  };

  return (
    <Router>
      <TrackPageView />
      <ScrollToTop />
      <ToastContainer position="top-center" />

      <div>
        {/* Admin */}

        <Routes>
          {" "}
          <Route path="/Admin" element={<LoginPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
        </Routes>
        {isAdmin && (
          <>
            <AdminSideNav
              NameAdmin={NameAdmin}
              AdminRole={AdminRole}
              Admin={Admin}
              logout={handleAdminLogout}
            />
            <Routes>
              <Route
                path="/Admin/billing/:id"
                element={<StatisticsDashboard Admin={Admin} />}
              />
              <Route
                path="/Admin/dashboard"
                element={<AdminDashboard Admin={Admin} />}
              />
              <Route
                path="/Admin/whatsapp"
                element={<ClientAccordionTable Admin={Admin} />}
              />
              <Route
                path="/Admin/WhatsAppUser"
                element={<AdminCampaigns Admin={Admin} />}
              />
              <Route
                path="/admin/Whitelist"
                element={<ChatComponent Admin={Admin} />}
              />
              <Route
                path="/admin/createclient"
                element={<ClientCreationPage Admin={Admin} />}
                z
              />
            </Routes>
          </>
        )}

        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(breadcrumbData)}
          </script>
        </Helmet>
        <Routes>
          {!user && (
            <>
              <Route path="/get" element={<MyLanding onLoginClick={login} />} />

              <Route
                path="/"
                element={
                  <Home
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/identity"
                element={
                  <IdentityPage
                    power={power}
                    setUser={setUser}
                    setPower={setPower}
                  />
                }
              />

              <Route
                path="/PrivacyPolicy"
                element={
                  <Privacy
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />
              <Route
                path="/terms&conditions"
                element={
                  <TAndC
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />

              <Route
                path="/about"
                element={
                  <Aboutpage
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />
              <Route
                path="/whatsapp-campaign"
                element={
                  <WhatsappCampaign
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />
              <Route
                path="/audience-targeting"
                element={
                  <AudienceTargating
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />
              <Route
                path="/personalized-message"
                element={
                  <PersonalisedMessage
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />
              <Route
                path="/automated-reply"
                element={
                  <AutomatedReply
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />
              <Route
                path="/Pricing-section"
                element={
                  <Pricingpage
                    onSignUpClick={signUp}
                    onLoginClick={login}
                    country={country}
                    handleCountryChange={handleCountryChange}
                  />
                }
              />
            </>
          )}
        </Routes>
        {user ? (
          <>
            <NavigationBar
              setUser={setUser}
              handleLogout={handleLogout}
              userID={userID}
            />
            <div style={{ flex: 1, paddingLeft: "145px" }}>
              <Routes>
                {power === "1" ? (
                  <>
                    <Route
                      path="/Dashboard"
                      element={
                        <Dashboard
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Dashboard2"
                      element={
                        <Dashboard2
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Create-Template"
                      element={
                        <CreateTemplate
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp"
                      element={
                        <Chats
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/ContactBook"
                      element={
                        <ContactBook
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/ChatBot"
                      element={
                        <ChatBot
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/ChatBotStop"
                      element={
                        <ChatBot
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Campaign"
                      element={
                        <CreateCampaign
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Template"
                      element={
                        <DLTTamplate
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Manage"
                      element={
                        <Campaign
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Logs"
                      element={
                        <Logs
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/TemplateLibrary"
                      element={
                        <TemplateLibrary
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/TemplateLibrary/Edit"
                      element={
                        <EditLibrary
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile"
                      element={
                        <ProfileSetting
                          profiles={profiles}
                          power={power}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/Setting"
                      element={
                        <OrderSettings
                          profiles={profiles}
                          power={power}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />

                    <Route
                      path="/Profile/Setup"
                      element={
                        <Setup
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/UserManagement"
                      element={
                        <UserManagement
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/SupportCenter"
                      element={
                        <SupportCenter
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/CampaignDetails"
                      element={
                        <CampaignDetails
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Manage/CampaignView"
                      element={
                        <CampaignView
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/TemplateView"
                      element={
                        <TemplateView
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Template/TemplateEdit"
                      element={
                        <TemplateEdit
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/WelcomePage"
                      element={
                        <WelcomePage
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Billing"
                      element={
                        <Billing
                          userID={userID}
                          profiles={profiles}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/ExpiredPlan"
                      element={
                        <ExpiredPlan
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/WhatsApp/Onboarding"
                      element={
                        <FacebookOnBoarding
                          userID={userID}
                          profiles={profiles}
                        />
                      }
                    />
                  </>
                ) : (
                  <>
                    {/* <Navigate to="/Profile" replace /> */}
                    <Route
                      path="/ExpiredPlan"
                      element={
                        <ExpiredPlan
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile"
                      element={
                        <ProfileSetting
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />

                    <Route
                      path="/Profile/Setup"
                      element={
                        <Setup
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/WelcomePage"
                      element={
                        <WelcomePage
                          userID={userID}
                          profiles={profiles}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                    <Route
                      path="/Profile/UserManagement"
                      element={
                        <UserManagement
                          userID={userID}
                          DeveloperID={DeveloperID}
                          keyId={keyId}
                        />
                      }
                    />
                  </>
                )}
              </Routes>
            </div>
          </>
        ) : (
          <Routes>
            {/* <Route path="/" element={<Login login={login} />} /> */}
          </Routes>
        )}
      </div>
      {!user ? <ChatBotHome /> : <ExternalChatBot />}
    </Router>
  );
};

export default App;
